/* ─────────────────────────────────────────────────
   hero-banner-video.js
   DEV-2026-0351: Das Video startet erst, wenn die Seite fertig geladen ist.
   Vorher zog es als HLS-Stream Bandbreite genau dann ab, wenn das Hero-Bild
   sie braucht — das Video war damit das LCP-Element mit ueber 11 Sekunden.
   Bis dahin steht sein Thumbnail (poster), das im Banner vorgeladen wird.

   DEV-2026-0349: Video im Hero-Banner bekommt 5 Sekunden Zeit zum Laden.
   Solange laeuft das Video-Thumbnail (poster) als Zwischenbild. Ist das
   Video danach immer noch nicht abspielbar — oder faellt es mit einem
   Fehler aus — wird es ausgeblendet und das hinterlegte Bild uebernimmt.
   Ein leerer/weisser Bereich entsteht dadurch zu keinem Zeitpunkt.
   ───────────────────────────────────────────────── */
(function () {
  'use strict';

  var TIMEOUT_MS = 5000;
  var FALLBACK_CLASS = 'hero-banner__video--fallback';

  /* Bildschicht fuer den Viewport dieses Videos sichtbar schalten. */
  function revealImage(video) {
    var section = video.closest('.hero-banner');
    var picture = section && section.querySelector('.hero-banner__fallback-image');
    if (!picture) return;
    var viewport = video.dataset.heroViewport === 'desktop' ? 'desktop' : 'mobile';
    picture.classList.add('hero-banner__fallback-image--show-' + viewport);
  }

  /* Quellen anhaengen und Wiedergabe starten. Vorher haengt am <video> nichts
     als das Poster, es kostet also keine Bandbreite. */
  function activate(video) {
    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;
    Array.prototype.forEach.call(sources, function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.muted = true; // iOS spielt nur stumm automatisch ab
    video.load();
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  }

  function initVideo(video) {
    if (video.dataset.heroVideoInit === 'true') return;
    video.dataset.heroVideoInit = 'true';

    var settled = false;
    var timer = null;

    function settle(useFallback) {
      if (settled) return;
      settled = true;
      if (timer) clearTimeout(timer);
      // Ohne hinterlegtes Bild bleibt das Video (und damit sein Poster) stehen —
      // ausblenden wuerde hier genau den weissen Bereich erzeugen.
      if (!useFallback || video.dataset.heroFallback !== 'image') return;
      revealImage(video);
      video.classList.add(FALLBACK_CLASS);
      video.removeAttribute('autoplay');
      try {
        video.pause();
      } catch (e) {
        /* egal — das Video ist ohnehin unsichtbar */
      }
    }

    // Ohne Poster hat das Video nichts zu zeigen, solange es laedt — dann
    // uebernimmt das Bild sofort die Ueberbrueckung statt einer weissen Flaeche.
    if (!video.getAttribute('poster') && video.dataset.heroFallback === 'image') {
      revealImage(video);
    }

    // HAVE_FUTURE_DATA: genug gepuffert, um zu starten
    if (video.readyState >= 3) {
      settle(false);
      return;
    }

    video.addEventListener('canplay', function () { settle(false); }, { once: true });
    video.addEventListener('playing', function () { settle(false); }, { once: true });
    video.addEventListener('error', function () { settle(true); }, { once: true });

    // Fehler einzelner <source>-Elemente bubbeln nicht ans <video>.
    Array.prototype.forEach.call(video.querySelectorAll('source'), function (source) {
      source.addEventListener('error', function () {
        if (video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) settle(true);
      });
    });

    timer = setTimeout(function () { settle(true); }, TIMEOUT_MS);
    activate(video);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('.hero-banner__video'), initVideo);
  }

  /* DEV-2026-0351: erst nach dem Seitenaufbau, und dann in einer Leerlaufphase —
     so konkurriert der Videostream nicht mehr mit dem Hero-Bild um Bandbreite. */
  function startWhenIdle() {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () { initAll(document); }, { timeout: 2000 });
    } else {
      setTimeout(function () { initAll(document); }, 200);
    }
  }

  if (document.readyState === 'complete') {
    startWhenIdle();
  } else {
    window.addEventListener('load', startWhenIdle, { once: true });
  }

  // Theme-Editor: Section wird neu gerendert
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
